(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-promo-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-gm-promo-carousel]');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-gm-promo-track]');
      const slideCount = track ? track.children.length : 0;
      if (!track || slideCount < 2) return;

      let current = 0;
      let timer = null;

      const render = () => {
        track.style.transform = `translateX(-${current * 100}%)`;
      };

      const start = () => {
        clearInterval(timer);
        timer = window.setInterval(() => {
          current = (current + 1) % slideCount;
          render();
        }, 3000);
      };

      render();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm2-promo-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-gm-promo-carousel]');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-gm-promo-track]');
      const slideCount = track ? track.children.length : 0;
      if (!track || slideCount < 2) return;

      let current = 0;
      let timer = null;

      const render = () => {
        track.style.transform = `translateX(-${current * 100}%)`;
      };

      const start = () => {
        clearInterval(timer);
        timer = window.setInterval(() => {
          current = (current + 1) % slideCount;
          render();
        }, 3000);
      };

      render();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
